export const INPUT_TYPES = {
  email: "email",
  text: "text",
  number: "number",
  url: "url",
  tel: "tel",
  country: "country",
  state: "state",
  checkbox: "checkbox",
  boolean: "boolean",
  hidden: "hidden",
  address: "address",
  mailingPhysicalAddress: "mailingPhysicalAddress",
  regions: "regions",
  freightForwarders: "freightForwarders",
  bondValue: "bondValue",
  date: "date",
  info: "info",
};
